import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster as Sonner } from 'sonner';
const Toaster = (props) => {
    return _jsx(Sonner, { ...props });
};
export { Toaster };
